import { render, staticRenderFns } from "./ClarifyReciept.vue?vue&type=template&id=70505f4a&scoped=true&"
import script from "./ClarifyReciept.vue?vue&type=script&lang=js&"
export * from "./ClarifyReciept.vue?vue&type=script&lang=js&"
import style0 from "./ClarifyReciept.vue?vue&type=style&index=0&id=70505f4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70505f4a",
  null
  
)

export default component.exports